/**
 * Service lines - the kinds of work a provider is enrolled for (D871 program §3.1, ADR-0160).
 *
 * `MOBILITY` (carrying passengers), `PARCEL` (sending packages) and `FOOD` (delivering meals) are PLATFORM vocabulary: the kernel and the dispatch predicates
 * speak them. Whether a market runs a line, which vehicle classes it uses and what it requires are DATA of the governed key `provider.serviceLines`
 * (`@vello/config`), never a list here. Owner Q1: one `MOBILITY` line whatever the vehicle (car and moto rides are vehicle approvals inside it).
 *
 * The vehicle classes are `@vello/service-categories` `VEHICLE_CLASSES`. Neutral: no country, document or language is named.
 */
import { VEHICLE_CLASSES } from '@vello/service-categories';
export const SERVICE_LINES = ['MOBILITY', 'PARCEL', 'FOOD'];
export const isServiceLine = (v) => typeof v === 'string' && SERVICE_LINES.includes(v);
export { VEHICLE_CLASSES };
export const isVehicleClass = (v) => typeof v === 'string' && VEHICLE_CLASSES.includes(v);
/** The version of the kernel's own fixed rules (the state machines, the delta, the one-mode rule, the parcel class match). */
export const PROVIDER_SERVICES_KERNEL_VERSION = 'provider-services@2';
/** Whether an item limited to `vehicleClasses` (empty = every class) applies to a vehicle of `vehicleClass`. */
export function appliesToClass(item, vehicleClass) {
    return item.vehicleClasses.length === 0 || item.vehicleClasses.includes(vehicleClass);
}
/** The requirements of a line for a vehicle of `vehicleClass`. */
export function requirementsFor(rule, vehicleClass) {
    return rule.requirements.filter((r) => appliesToClass(r, vehicleClass));
}
/** The equipment a line requires for a vehicle of `vehicleClass` (confirmed at go-online). */
export function equipmentFor(rule, vehicleClass) {
    return rule.equipment.filter((e) => appliesToClass(e, vehicleClass));
}
/**
 * Whether a line's rule refuses a vehicle class: the class is not one it lists, whether the line is on or off. The ONE class rule - the grants
 * (`lineRefusal`), the seed's backfill filter and the closing of old approvals (D904) all read it.
 */
export function lineRefusesClass(rule, vehicleClass) {
    return !rule.vehicleClasses.includes(vehicleClass);
}
export function lineRefusal(rule, vehicleClass) {
    if (rule === undefined)
        return 'LINE_NOT_DEFINED';
    if (!rule.enabled)
        return 'LINE_NOT_ENABLED';
    if (lineRefusesClass(rule, vehicleClass))
        return 'VEHICLE_CLASS_NOT_ALLOWED_FOR_LINE';
    return undefined;
}
//# sourceMappingURL=lines.js.map